module.exports = __webpack_public_path__ + "images/26365eb79b9d33c0c315da22336540bd.svg";